import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { HomeComponent } from './features/home/home.component';
import { WidgetConsentimientoComponent } from './features/widget-consentimiento/widget-consentimiento.component';
import { ConsentimientoMarcaComponent } from './features/consentimiento-marca/consentimiento-marca.component';
import { ConsentimientoGenericoComponent } from './features/consentimiento-generico/consentimiento-generico.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent },
  { path: 'widget-consentimiento', component: WidgetConsentimientoComponent },
  // 08-sep-2026, a pedido explícito del usuario: rutas textuales /Kaufmann y /andes-motor
  // (sin "widget" en el nombre, por lo mismo que ya se había hablado con Roberto: acá se
  // invoca el mismo componente pero grande, dentro de una página que simula el sitio real).
  { path: 'Kaufmann', component: ConsentimientoMarcaComponent, data: { marca: 'kaufmann' } },
  // /Kauffman (doble F) era la ruta original — quedó mal escrita por el mismo malentendido del
  // texto visible (ver consentimiento-marca.component.ts). Redirect por si ya se compartió ese link.
  { path: 'Kauffman', redirectTo: '/Kaufmann' },
  { path: 'andes-motor', component: ConsentimientoMarcaComponent, data: { marca: 'andes-motor' } },
  // 08-sep-2026, a pedido explícito: link genérico sin marca que un vendedor manda
  // directo al cliente (dinámica "consígueme la mayor cantidad de consentimientos") —
  // por eso NO simula ninguna página anfitriona, solo el formulario. 09-sep-2026: pegado
  // a la izquierda (pedido explícito de Roberto, ver ConsentimientoGenericoComponent).
  { path: 'consentimiento', component: ConsentimientoGenericoComponent, data: { posicion: 'izquierda' } },
  // 09-sep-2026, a pedido explícito: 3 variantes de color de la misma página genérica,
  // las 3 pegadas a la izquierda (mismo criterio que /consentimiento) — para que Roberto
  // elija cuál paleta usar. web1 = los mismos colores neutros de siempre; web2 y web3 son
  // fondo/letra invertidos entre sí. El color de botón no se pidió explícito para web2/web3
  // — se eligió invertido (blanco sobre negro / negro sobre blanco) por contraste, ajustable.
  // 09-sep-2026, a pedido explícito: "Quiero ver más información" en gris placeholder
  // (#9aa2ad, el mismo de los inputs) en vez del navy oscuro fijo — solo acá.
  {
    path: 'web1consentimiento',
    component: ConsentimientoGenericoComponent,
    data: {
      posicion: 'izquierda',
      // fondo #3C425073 = rgba(60, 66, 80, 0.45) en hex de 8 dígitos (#RRGGBBAA).
      colores: { texto: '#ffffff', fondo: '#3C425073', boton: '#55606b', textoBoton: '#ffffff', masInfo: '#9aa2ad' },
    },
  },
  {
    path: 'web2consentimiento',
    component: ConsentimientoGenericoComponent,
    data: {
      posicion: 'izquierda',
      colores: { texto: '#ffffff', fondo: '#000000', boton: '#ffffff', textoBoton: '#000000', masInfo: '#9aa2ad' },
    },
  },
  {
    path: 'web3consentimiento',
    component: ConsentimientoGenericoComponent,
    data: {
      posicion: 'izquierda',
      colores: { texto: '#000000', fondo: '#ffffff', boton: '#000000', textoBoton: '#ffffff', masInfo: '#9aa2ad' },
    },
  },
  // /webconsentimiento era el nombre viejo de lo que ahora es /web1consentimiento.
  { path: 'webconsentimiento', redirectTo: '/web1consentimiento' },
  { path: '', redirectTo: '/login', pathMatch: 'full' }
];
